













import { defineComponent, computed, watch, ref, onMounted } from '@vue/composition-api';
import { isInEditor, pingEditor } from '@/storyblok';
import { messenger } from '../../messenger';

export default defineComponent({
  name: 'EmbeddedVimeoVideo',
  props: { blok: { type: Object, required: true } },
  setup(props) {
    const inEditor = ref(false);
    const urlAdded = ref(false);

    onMounted(async () => {
      await pingEditor();
      inEditor.value = isInEditor();
    });

    watch(
      [inEditor, props.blok.videoId],
      () => {
        urlAdded.value = inEditor.value || process.env.VUE_APP_WEB;
        messenger.unity?.webview.excludeUrlFromOpeningExternally(props.blok.videoId).then(() => {urlAdded.value = true}).catch();
      },
      {
        immediate: true,
      }
    );
    return {
      src: computed(() => `https://player.vimeo.com/video/${props.blok.videoId}`),
      urlAdded,
    };
  },
});
